/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionAuthSupportsRequestStats } from '../../models/subscription-auth-supports-request-stats';
import { UidsBody } from '../../models/uids-body';

export interface GetSubscriptionsAuthSupportsRequestStats$Params {
      body: UidsBody
}

export function getSubscriptionsAuthSupportsRequestStats(http: HttpClient, rootUrl: string, params: GetSubscriptionsAuthSupportsRequestStats$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubscriptionAuthSupportsRequestStats>>> {
  const rb = new RequestBuilder(rootUrl, getSubscriptionsAuthSupportsRequestStats.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubscriptionAuthSupportsRequestStats>>;
    })
  );
}

getSubscriptionsAuthSupportsRequestStats.PATH = '/custom/subscriptions/auth-supports-requests/stats';
